import { Button, Icon, Text } from 'ab-uitools-legacy'
import logo from '../../assets/header_logo.svg'
import { useIsMobile } from '../../hooks/useIsMobile'
import { noop } from '../../utils'
import './index.scss'

const Header = () => {
  const isMobile = useIsMobile()

    const handleLogout = () => {
      document.location = '/auth/logout';
    }

  return (
    <div className="header">
      <img className="header_logo" src={`${logo}`} alt="logo" />

      <Button
        buttonText={
          <div className="logout_button">
              <Icon name="logout" size="small" type="secondary" />
              {!isMobile ? (
                <Text className="buttonText" size="medium">
                  Դուրս գալ
                </Text>
              ) : null}
          </div>
        }
        type="tertiary"
        onClick={handleLogout}
        className="submit-button"
      />
    </div>
  )
}

export default Header
